import React from "react";
import { NavItem } from "reactstrap";
import IconLogo from "../../_images/HerdPlan_Logo_Icon.svg";
import WhiteIconLogo from "../../_images/herdplan-logo-icon-white.png";
import HerdPlanLogo from "../../_images/herdplan-logo.svg";
import { MAIN_LANDING_PAGE } from "../../constants";

interface BrandProps {
  includeIcon?: boolean;
  iconOnly?: boolean;
  whiteIcon?: boolean;
}

export const Brand = ({
  includeIcon = true,
  iconOnly = false,
  whiteIcon,
}: BrandProps) => {
  return (
    <>
      {(includeIcon || iconOnly) && (
        <img
          src={whiteIcon ? WhiteIconLogo : IconLogo}
          className="NavLogo"
          alt="HerdPlan Icon"
        />
      )}
      {!iconOnly && (
        <img src={HerdPlanLogo} alt="HerdPlan Logo" className="NavLogo" />
      )}
    </>
  );
};

export const BrandLinkToLandingPage = ({ includeIcon }: BrandProps) => {
  return (
    <a href={MAIN_LANDING_PAGE} className="d-flex gap-2 nowrap">
      <Brand includeIcon={includeIcon} />
    </a>
  );
};

export const HeaderBrand = () => {
  return (
    <NavItem
      style={{
        position: "absolute",
        left: "50%",
        top: 0,
        transform: "translateX(-50%)",
        paddingTop: ".75em",
        minWidth: "max-content",
      }}
      title="HerdPlan homepage"
    >
      <BrandLinkToLandingPage />
    </NavItem>
  );
};
